/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.live.getRecommendations";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"userDID":/*#__PURE__*/ l.string({"format":"did"})});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"recommendations":/*#__PURE__*/ l.array(/*#__PURE__*/ l.typedUnion([/*#__PURE__*/ l.typedRef<LivestreamRecommendation>((() => livestreamRecommendation) as any)], false), ),"userDID":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"did"}))});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Get the list of streamers recommended by a user */
const main = /*#__PURE__*/ l.query($nsid, $params, $output);

export { main };

export const $lxm = $nsid;

type LivestreamRecommendation = { $type?: "place.stream.live.getRecommendations#livestreamRecommendation";

  /**
   * The DID of the recommended streamer
   */
  "did":l.DidString;

  /**
   * Source of the recommendation
   */
  "source":"streamer" | "follows" | "host" };

export type { LivestreamRecommendation };

const livestreamRecommendation = /*#__PURE__*/ l.typedObject<LivestreamRecommendation>($nsid, "livestreamRecommendation", /*#__PURE__*/ l.object({"did":/*#__PURE__*/ l.string({"format":"did"}),"source":/*#__PURE__*/ l.enum(["streamer","follows","host"])}));

export { livestreamRecommendation };
